"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../../constants");
const store_1 = require("../../../store");
const AuthenticationActions_1 = require("../../../authentication/AuthenticationActions");
function feedbacks(state = null, action) {
    switch (action.type) {
        case constants_1.ACTIONS.Feedbacks.SAVE_FEEDBACKS:
            {
                return Object.assign({}, state, {
                    loadingProgress: constants_1.ProgressState.Success,
                    feedbacks: action.payload.feedbacks
                });
            }
        case constants_1.ACTIONS.Feedbacks.SET_FILTER_DATES:
            return Object.assign({}, state, {
                filterDates: action.payload
            });
        case constants_1.ACTIONS.Feedbacks.SET_NEW_FEEDBACKS:
            return Object.assign({}, state, {
                newFeedbacks: action.payload
            });
        case constants_1.ACTIONS.Feedbacks.SET_UNREAD_FEEDBACKS:
            return Object.assign({}, state, {
                unreadFeedbackCount: action.payload
            });
        case constants_1.ACTIONS.Authentication.LOGOUT:
            store_1.default.dispatch(AuthenticationActions_1.deleteState());
            return state;
        case constants_1.ACTIONS.Authentication.DELETE_STATE:
            return constants_1.INITIAL_STATE.feedbacks;
        default:
            return state;
    }
}
exports.default = feedbacks;


//////////////////
// WEBPACK FOOTER
// ./client/src/app/business/feedback/FeedbacksReducer.ts
// module id = 784
// module chunks = 0 1 2